import axios from "axios";
import secureLocalStorage from "react-secure-storage";

const addFeedback = (name , description) => {
  const loginData = secureLocalStorage.getItem("loginCredentials");
  
  return new Promise((resolve, reject) => {
    axios
      .post(`${process.env.REACT_APP_NODE_BASE_URL}/feedback/api/feedback`, {
        name: name,
        email: loginData.user.email,
        description: description,
      
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => reject(err));
  });
};


  const getAllFeedback = () => {

    return new Promise((resolve, reject) => {
      axios
        .get(`${process.env.REACT_APP_NODE_BASE_URL}/feedback/api/admin/feedback`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => reject(err));
    });
  };




export { addFeedback, getAllFeedback };
